module.exports = {"accomodationTC":"https://storage.googleapis.com/maakler-contracts/BOOKING_ID%3AOWNER_UID%3ATENANT_UID%3A1570717875182.pdf","tenancyAgreement":"https://storage.googleapis.com/maakler-contracts/BOOKING_ID%3AOWNER_UID%3ATENANT_UID%3A1570717951383.pdf"}


//////////////////
// WEBPACK FOOTER
// ./src/config/contract_template_values.json
// module id = 5s8t
// module chunks = 1